/**
 * Created by jayed.talukder on 9/13/2018.
 */
/**
 * Created by shamim.ahsan on 9/9/2018.
 */

import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { PageInfo } from '@shared/models/page-info';
import {EntitySetting} from '../../../models/entity-setting.model';
import {TransactionState} from '../reducers/transaction.reducer';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {FieldDefinition} from '@shared/models/field-definition';
import {PagedResponseRow} from '@shared/models/paged-response-model';

export const getTransactionState = createFeatureSelector<TransactionState>(
  'cr-transaction'
);
export const getPayingEntities: MemoizedSelector<object, EntitySetting[]> = createSelector(
  getTransactionState,
  (state: TransactionState) => state.payingEntities
);

export const getReceivingEntities: MemoizedSelector<object, EntitySetting[]> = createSelector(
  getTransactionState,
  (state: TransactionState) => state.receivingEntities
);

export const getStreams: MemoizedSelector<object, PaymentStreamSetting[]> = createSelector(
  getTransactionState,
  (state: TransactionState) => state.streams
);

export const getTransactions = createSelector(
  getTransactionState,
  (state: TransactionState) => state.transactions.items
);

export const getTransactionsPageInfo = createSelector(
  getTransactionState,
  (state: TransactionState) => new PageInfo(state.transactions)
);

export const getTransactionFieldDefinitions: MemoizedSelector<object, FieldDefinition[]> = createSelector(
  getTransactionState,
  (state: TransactionState) => {
    const arr = state.transactionFieldDefinations;
    return arr;
  }
);

export const getRefreshSelectionCounter = createSelector(
  getTransactionState,
  (state: TransactionState) => state.refreshSelectionCounter
);
